const INDEXED_DB_DISCONNECT_PATTERN = /connection to indexed database server lost/i

function getStringProperty(
  value: unknown,
  key: string,
): string | undefined {
  if (!value || typeof value !== 'object') {
    return undefined
  }
  const record = value as Record<string, unknown>
  return typeof record[key] === 'string' ? record[key] : undefined
}

function toErrorMessage(error: unknown): string | null {
  if (typeof error === 'string') {
    return error
  }
  if (error instanceof Error) {
    return error.message
  }
  return getStringProperty(error, 'message') ?? null
}

function hasIndexedDbDisconnectMessage(value: unknown): boolean {
  const message = toErrorMessage(value)
  return message !== null && INDEXED_DB_DISCONNECT_PATTERN.test(message)
}

export function isIndexedDbDisconnectError(error: unknown): boolean {
  return hasIndexedDbDisconnectMessage(error)
}

interface SentryEventLike {
  message?: unknown
  logentry?: {
    formatted?: unknown
  }
  exception?: {
    values?: Array<{
      value?: unknown
    }>
  }
}

export function isIndexedDbDisconnectSentryEvent(event: unknown): boolean {
  if (!event || typeof event !== 'object') {
    return false
  }

  const sentryEvent = event as SentryEventLike
  if (hasIndexedDbDisconnectMessage(sentryEvent.message)) {
    return true
  }

  if (hasIndexedDbDisconnectMessage(sentryEvent.logentry?.formatted)) {
    return true
  }

  const exceptionValues = sentryEvent.exception?.values
  if (!Array.isArray(exceptionValues)) {
    return false
  }

  return exceptionValues.some((entry) => hasIndexedDbDisconnectMessage(entry.value))
}
